import type { TypedDocumentNode, UseMutationResponse } from '@urql/vue';
import MutationResponse from '~/graphql/wrappers/mutation-response';
import { ApiCall } from '~/graphql/wrappers/api-call';

export default class MutationCall<T = Mutation, V = any> extends ApiCall<T, V> {
  private mutation: UseMutationResponse<T, V>;

  constructor(mutationDocument: TypedDocumentNode<T, V>) {
    super();
    this.mutation = this.createMutation(mutationDocument);
  }

  public async run(input: V, extraVariables?: any): Promise<MutationResponse<T>> {
    const result = await this.mutation.executeMutation({ ...input, ...extraVariables });
    return new MutationResponse<T>(result);
  }
}
